<template>
  <div class="container mt-4 contact-us-page">
    <!-- Top Section: Intro and Donation -->
    <div class="row">
      <!-- Left: Intro & Updates -->
      <div class="col-lg-8 mb-4">
        <div class="card shadow-sm h-100">
          <div class="card-header bg-primary text-white d-flex align-items-center">
            <h5 class="mb-0">关于自在量化</h5>
          </div>
          <div class="card-body">
            <div class="alert alert-light border-left-primary" role="alert">
              <h5 class="alert-heading">欢迎来到 自在量化!</h5>
              <p class="mb-0">我们的目标：量化市场一切，欢迎各位提出有效建议！</p>
            </div>
            
            <hr>
            <h6 class="font-weight-bold mb-3 border-bottom pb-2">更新日志</h6>
            <ul class="list-unstyled update-log">
              <li class="mb-3">
                <span class="badge badge-info mr-2">2025.10.28</span>
                <span class="font-weight-bold">V2.3</span>：增加 <router-link to="/wonder/yjj/ml" class="font-weight-bold">资金净流入</router-link> 变化，判断板块的持续性。
              </li>
              <li class="mb-3">
                <span class="badge badge-info mr-2">2025.05.31</span>
                <span class="font-weight-bold">V2.2</span>：情绪增加 <router-link to="/sentiment/cyclicality/vip" class="font-weight-bold">情绪周期VIP</router-link> ，明确周期节点，风险和机会一目了然。
              </li>
              <li class="mb-3">
                <span class="badge badge-info mr-2">2025.05.27</span>
                <span class="font-weight-bold">V2.1</span>：复盘增加 <router-link to="/review/uplimit/progress" class="font-weight-bold">涨停推演</router-link> ，核心题材一目了然，推演配合模式。
              </li>
              <li class="mb-3">
                <span class="badge badge-secondary mr-2">2023.06.19</span>
                <span class="font-weight-bold">V2.0</span>：增加服务器优化速度，增加热点板块。
              </li>
              <li class="mb-3">
                <span class="badge badge-secondary mr-2">2021.02.21</span>
                <span class="font-weight-bold">V1.5</span>：各图增加最左拖动延伸数据以及标注月第一天和周一便于观察周期。
              </li>
              <li class="mb-3">
                <span class="badge badge-secondary mr-2">2021.01.21</span>
                <span class="font-weight-bold">V1.4</span>：新增情绪周期年度量化，什么时期玩大票，什么时期玩题材，什么时期观望。
              </li>
              <li class="mb-3">
                 <span class="badge badge-secondary mr-2">2020.09.10</span>
                 <span class="font-weight-bold">V1.3</span>：新增情绪分时、人气分时以及日K的人气和情绪，便于把握情绪节点。
              </li>
               <li class="mb-3">
                 <span class="badge badge-secondary mr-2">2020.08.09</span>
                 <span class="font-weight-bold">V1.2</span>：新增复盘模块的K线、分时、板块、涨停原因(点击标的)，新增“复盘-涨停晋级”方便查看历史。
              </li>
               <li class="mb-3">
                 <span class="badge badge-secondary mr-2">2020.08.02</span>
                 <span class="font-weight-bold">V1.1</span>：新增主情绪日K图，人气日K图，在情绪周期模块，原情绪周期改为空间板。
              </li>
               <li class="mb-3">
                 <span class="badge badge-secondary mr-2">2020.07.26</span>
                 <span class="font-weight-bold">V1.0</span>：上线三个模块：情绪量化，涨停复盘，机器人常用功能说明。
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Right: Donation -->
      <div class="col-lg-4 mb-4">
        <div class="card shadow-sm h-100">
          <div class="card-header bg-danger text-white">
            <h5 class="mb-0">支持我们</h5>
          </div>
          <div class="card-body text-center d-flex flex-column justify-content-center">
            <p class="text-muted mb-4">感谢您的支持，捐赠将用于服务器费用</p>
            
            <div class="mb-4">
              <img class="img-fluid rounded border p-1 shadow-sm" style="max-width: 180px;" src="~assets/img/wx_zsm.png" alt="微信赞赏">
              <div class="mt-2 small text-muted font-weight-bold">微信赞赏</div>
            </div>
            
            <div>
              <img class="img-fluid rounded border p-1 shadow-sm" style="max-width: 150px;" src="~assets/img/jz_cjj_zfb.jpg" alt="支付宝捐赠">
              <div class="mt-2 small text-muted font-weight-bold">支付宝捐赠</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Contact Section -->
    <div class="row mb-3">
        <div class="col-12">
            <h5 class="pl-3 border-left border-primary text-primary font-weight-bold">联系方式</h5>
        </div>
    </div>
    
    <div class="row">
      <div class="col-md-4 mb-4">
        <div class="card shadow-sm h-100 text-center p-3 contact-card">
          <div class="mb-3 img-container">
             <img class="img-fluid rounded" src="~assets/img/cjj3.jpg" alt="作者微信" />
          </div>
          <h6 class="font-weight-bold text-dark">作者微信</h6>
          <p class="text-muted small mb-0">加入讨论群请备注</p>
          <p class="text-muted small">老群有空位优先填上</p>
        </div>
      </div>

      <div class="col-md-4 mb-4">
        <div class="card shadow-sm h-100 text-center p-3 contact-card">
          <div class="mb-3 img-container">
            <img class="img-fluid rounded" src="~assets/img/zzquant.jpg" alt="公众号" />
          </div>
          <h6 class="font-weight-bold text-dark">微信公众号</h6>
          <p class="text-muted small mb-0">很随意的一些分享</p>
        </div>
      </div>

      <div class="col-md-4 mb-4">
        <div class="card shadow-sm h-100 text-center p-3 contact-card">
          <div class="mb-3 img-container">
            <img class="img-fluid rounded" src="~assets/img/cjj_hd.jpg" alt="视频号" />
          </div>
          <h6 class="font-weight-bold text-dark">微信视频号</h6>
          <p class="text-muted small mb-0">分享一些有价值的知识</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactUs'
}
</script>

<style scoped>
.contact-us-page {
  max-width: 1200px;
}
.border-left-primary {
    border-left: 4px solid #007bff;
}
.update-log li {
    font-size: 0.95rem;
    line-height: 1.6;
}
.contact-card {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border: none;
}
.contact-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 .5rem 1rem rgba(0,0,0,.15)!important;
}
.img-container {
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}
.img-container img {
    max-height: 100%;
    max-width: 100%;
    object-fit: contain;
}
</style>
